import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Refine } from "@refinedev/core";
import { RefineThemes, ThemedLayoutV2 } from "@refinedev/antd";
import routerProvider from "@refinedev/react-router-v6";
import { dataProvider } from "@/services/dataProvider";
import { authProvider } from "@/services/authConfig";
import { App } from "./App";
import frFR from "antd/locale/fr_FR";
import "antd/dist/reset.css";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        ...RefineThemes.Blue,
        token: { ...RefineThemes.Blue.token, colorPrimary: "#265A50", colorInfo: "#265A50" },
      }}
      locale={frFR}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_startTransition: true }}>
          <Refine
            routerProvider={routerProvider}
            dataProvider={dataProvider}
            authProvider={authProvider}
            resources={[
              {
                name: "dashboard",
                list: "/",
                meta: {
                  label: "Dashboard",
                  icon: "📊",
                },
              },
              {
                name: "contents",
                list: "/content",
                create: "/content/create",
                edit: "/content/edit/:id",
                show: "/content/show/:id",
                meta: {
                  label: "Contenu",
                  icon: "🎬",
                },
              },
              {
                name: "users",
                list: "/users",
                edit: "/users/edit/:id",
                show: "/users/show/:id",
                meta: {
                  label: "Utilisateurs",
                  icon: "👥",
                },
              },
              {
                name: "actors",
                list: "/artists",
                create: "/artists/create",
                edit: "/artists/edit/:id",
                show: "/artists/show/:id",
                meta: {
                  label: "Artistes & Réalisateurs",
                  icon: "🎭",
                },
              },
              {
                name: "notifications",
                list: "/notifications",
                create: "/notifications/create",
                edit: "/notifications/edit/:id",
                meta: {
                  label: "Notifications",
                  icon: "🔔",
                },
              },
              {
                name: "genres",
                list: "/categories",
                create: "/categories/create",
                edit: "/categories/edit/:id",
                meta: {
                  label: "Catégories & Genres",
                  icon: "🏷️",
                },
              },
            ]}
            options={{
              syncWithLocation: true,
              warnWhenUnsavedChanges: true,
            }}
          >
            <App />
          </Refine>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>
);
